var klaviyo = klaviyo || [];
klaviyo.init({
  account: "NNRzid",
  platform: "shopify",
  exclude_on_tags: "oos",
});
klaviyo.enable("backinstock", {
  trigger: {
    product_page_text: "NOTIFY ME WHEN AVAILABLE",
    product_page_class: "btn",
    product_page_text_align: "center",
    product_page_margin: "0px",
    replace_anchor: true,
  },
  modal: {
    headline: "{product_name}",
    body_content: "Register to receive a notification when this item comes back in stock.",
    email_field_label: "Email",
    button_label: "NOTIFY ME WHEN AVAILABLE",
    subscription_success_label: "You're in! We'll let you know when it's back.",
    footer_content: "",
    additional_styles:
      "@import url('https://cdn.shopify.com/s/files/1/0038/6049/6433/files/custom-klaviyo-bis-trigger-css.css?v=1711568787')",
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#222",
    button_text_color: "#fff",
    button_background_color: "#008fbb",
    close_button_color: "#ccc",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#d3efcd",
    success_text_color: "#1B9500",
    font_family: "Encode Sans Condensed",
  },
});
